/**
 * The Settings-targeted Needs-you items (TMMPDM-0088 Step 13 items 6 and 7), each from one server
 * field, for the Settings tab's count and the side menu's dots. Item 6's target follows the tenant's
 * `sellableReason` alone; item 7 is the standing's `officialLaunchOn === null` once the standing has
 * loaded. No item is suppressed because of another. Item 9 is not built
 * (Operator, 2026-10-07: tmm-api 0154 retired its flag).
 */
import type { SellableReason } from '@/api/tmm/types';
import type { TabKey } from './partnerSections';

/** Where Can't sell is fixed: the agreement, or the rate card. Other reasons have no Settings leaf. */
export function sellableTarget(reason: SellableReason | null | undefined): TabKey | null {
  switch (reason) {
    case 'NO_AGREEMENT':
    case 'CURRENCY_NOT_PRICED':
      return 'agreement';
    case 'NO_RATE_CARD':
      return 'priceCard';
    default:
      return null;
  }
}

export interface SettingsNeeds {
  /** How many Settings-targeted items show. */
  count: number;
  /** The leaves an item opens. */
  targets: ReadonlySet<TabKey>;
}

export function settingsNeeds({
  sellableReason,
  launchUnset,
}: {
  sellableReason: SellableReason | null | undefined;
  /** The standing has loaded and its `officialLaunchOn` is `null`. */
  launchUnset: boolean;
}): SettingsNeeds {
  const targets: TabKey[] = [];
  const sellable = sellableTarget(sellableReason);
  if (sellable !== null) targets.push(sellable);
  if (launchUnset) targets.push('agreement');
  return { count: targets.length, targets: new Set(targets) };
}
